import React, { useEffect } from "react";

const AdsterraIntegration = () => {
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "//pl19893461.highrevenuegate.com/02/20/6b/02206b7100b387aa7a01e2516d782fca.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "//pl19768117.highrevenuegate.com/8f4e9148783128aa60512fdbf86ed4b5/invoke.js";
    script2.async = true;
    script2.setAttribute("data-cfasync", "false");
    document.body.appendChild(script2);
  }, []);

  return <div id="container-8f4e9148783128aa60512fdbf86ed4b5"></div>;
};

export default AdsterraIntegration;
